module.exports = "/images/home5-bg.png?aa5e51d7079d06802a1280cca04feee6";